import axios from "axios";
import { SERVICE_URL, getHeaders } from "@/apis/common";

export function ping() {
  const url = `${SERVICE_URL}/ping`;

  return axios.get(url).then(res => res.data);
}

export function pingWithToken(token) {
  const url = `${SERVICE_URL}/token-ping`;
  const headers = getHeaders(token);
  const config = {
    headers,
  };

  return axios.get(url, config).then(res => res.data);
}
